import styled from 'styled-components';

export const Container = styled.div`
  margin: 10px;
`;

export const Button = styled.button`
  padding: 10px 15px;
  border: none;
  background-color: ${(props) => props.BC};
  color: white;
  &:active,
  &:hover {
    background-color: #464141;
  }
  &:focus {
    outline: none;
  }
`;
